import { render, staticRenderFns } from "./Bookkeeper.vue?vue&type=template&id=dd35785a"
import script from "./Bookkeeper.vue?vue&type=script&lang=js"
export * from "./Bookkeeper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports